import type { ElementType } from "react";
import { createElement } from "react";
import type { BoxElement } from "../Box/Box";
import { Flex, type FlexProps } from "../Flex/Flex";

export type StackProps<T extends BoxElement = "div"> = Omit<FlexProps<T>, "direction"> & {
  direction?: "vertical" | "horizontal";
};

const directionToFlex = {
  vertical: "column",
  horizontal: "row",
} as const;

export function Stack<T extends BoxElement = "div">({
  direction = "vertical",
  align = "stretch",
  ...rest
}: StackProps<T>) {
  return createElement(
    Flex as unknown as ElementType,
    {
      "data-component": "Stack",
      ...rest,
      direction: directionToFlex[direction],
      align,
    } as unknown as FlexProps<T>,
  );
}

Stack.displayName = "Stack";
